module.exports = __webpack_public_path__ + "static/media/Logo_QFX.67227f41.png";